export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "'Montserrat', sans-serif",
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "'Montserrat', sans-serif",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Montserrat', sans-serif",
    "@media (max-width:767px)": {
      fontSize: "16px",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "'Montserrat', sans-serif",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    color: "#e6e5e8",
    fontFamily: "'Montserrat', sans-serif",
  },
  h6: {
    fontWeight: 400,
    fontSize: 14,
    color:"#FFFFFF",
    fontFamily: "'Montserrat', sans-serif",
    "@media (max-width:767px)": {
      fontSize: "12px",
    },
  },
  body2: {
    fontWeight: 500,
    fontSize: 14,
    fontFamily: "'Montserrat', sans-serif",
    "@media (max-width:767px)": {
      fontSize: "10px",
    },
  },
  body1: {
    fontWeight: 500,
    fontSize: 12,
    color:"#FFFFFF",
    fontFamily: "'Montserrat', sans-serif",
    "@media (max-width:767px)": {
      fontSize: "10px",
    },
  },
  body3: {
    fontWeight: 400,
    fontSize: 13,
    fontFamily: "'Montserrat', sans-serif",
    lineHeight: "25px",
    color: "gray",
  },
  body4: {
    fontWeight: 400,
    fontSize: 13,
    fontFamily: "'Montserrat', sans-serif",
    lineHeight: "25px",
    color: "white",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Montserrat', sans-serif",
  },
  subtitle2: {
    fontWeight: 400,
    fontSize: 12,
    fontFamily: "'Montserrat', sans-serif",
  },
  subtitle3: {
    fontWeight: 500,
    fontSize: 11,
    fontFamily: "'Montserrat', sans-serif",
  },
};
